import React, { useEffect, useState } from 'react'

export default function Slider() {

  const slides = [1,2,3,4,5,6]

  const [state, setState] = useState({
      slide:1,
      playing:false
  })

  useEffect(()=>{
    let play = null;
    const init = async () => {
      play = setInterval(()=>{
        let slide = state.slide;
        if(state.slide < slides.length){
          slide = slide + 1
        }else{
          slide = 1
        }
        state.slide = slide;
        console.log(state.slide)

       


        setState({...state, playing:true})
      },10000)
    }
    init()
    return () => {clearInterval(play)}
  },[])




  return (
    <>
    <div className='bv-slider'>


        <img className={`${state.slide === 1 ? 'd-block' : 'd-none'}`} src={`/assets/1.png`}></img>
        <img className={`${state.slide === 2 ? 'd-block' : 'd-none'}`} src={`/assets/2.png`}></img>
        <img className={`${state.slide === 3 ? 'd-block' : 'd-none'}`} src={`/assets/3.png`}></img>
        <img className={`${state.slide === 4 ? 'd-block' : 'd-none'}`} src={`/assets/4.png`}></img>
        <img className={`${state.slide === 5 ? 'd-block' : 'd-none'}`} src={`/assets/5.png`}></img>
        <img className={`${state.slide === 6 ? 'd-block' : 'd-none'}`} src={`/assets/6.png`}></img>
    
        {/* <img src={`/assets/${state.slide}.png`}></img> */}

        {/* <div className='bv-slider-info'>

          <div className='container-fluid'>

            <div className='row'>

              <div className='col-12 col-md-8 order-1 order-md-0'>
                            
                <div className='text-dark f-32 bold'>Titulo</div>
                <div className='text-dark f-18 py-3'>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown
                </div>

                <div>
                  <div className='bv-cta bv-cta--primary'>Leer más</div>
                </div>

              </div>

              <div className='col-12 col-md-4 order-0 order-md-1'>
                  <img width={360} className="img-fluid d-block mx-auto" src='assets/d1.png'></img>
              </div>

            </div>

          </div>

            
        </div> */}
        
    </div>

    <div className='d-flex align-items-center justify-content-center mt-3'>

        {
          slides.map((item, i) => {
            return (
              <div key = {i} className={`bv-slider-dot cursor-pointer ${state.slide === item ? 'bv-slider-dot--active':''}`} onClick={()=>{
                setState({...state, slide:item})
              }}></div>
            )
          })
        }


  </div>
  </>
  )
}
